// src/api/retailers.js
import { get, post, put } from "./api";

export const searchRetailers = (q) =>
  get("/retailers/search", { params: { q } });

export const createRetailer = (data) =>
  post("/retailers", { ...data, dummy: false });

export const getRetailers = (q) =>
  get("/retailers", { params: q });

export const assignRetailerRoute = (data) => {
  put("/retailers/route", data)
}
